// @flow

/**
 * Answer Summary Component
 * Renders the <answer-summary> block. The summary is always visible: it is the
 * only content shown while the detail is collapsed, and it remains on screen
 * above the detail when the detail is expanded. Because it is never hidden, it
 * needs no export-time clipping. Renders NO toggle button — the toggle lives in
 * AnswerDetail so a malformed response with a detail block but no summary block
 * still gets a working toggle.
 */

import React from 'react';

type Props = {
  children?: React$Node,
};

const AnswerSummary = ({ children }: Props): React$Node => (
  <React.Fragment>{children}</React.Fragment>
);

export default AnswerSummary;
